<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailDevs"
      role="dialog"
      tabindex="-1"
      style="backdrop-filter: blur(3px)"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div style="background-color: #dddeff" class="modal-header faded smaller">
            <h6 class="modal-title text-center">Lista de devoluciones de proveedor</h6>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div style="overflow-y: scroll; max-height: 390px" class="table-responsive">
              <!-------------------- Tabla de Resultados -------------------->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Dev. #</th>
                    <th>Pendiente</th>
                    <th>Referencia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in devs" v-bind:key="det.id" @click="rowClick(det)">
                    <td>{{ det.numero }}</td>
                    <td>Q{{ det.pendiente }}</td>
                    <td>
                      <span v-if="det.referencia">{{ det.referencia }}</span>
                      <span v-else>.........</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
              <i class="fa fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalInfoDevs"
      role="dialog"
      tabindex="-1"
      style="background-color: transparent; backdrop-filter: blur(3px)"
    >
      <div class="modal-dialog" role="document">
        <div style="background-color: #e7f1e7" class="modal-content">
          <div class="modal-body">
            <!-------------------- Tabla de Resultados -------------------->
            <div class="text-center" style="background-color: rgb(144, 238, 144)">
              <h6 v-if="current_devolucion">
                Información Devolución #{{ current_devolucion.numero }}
              </h6>
            </div>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td style="padding: 0.1px" class="text-left font-weight-bold">Fecha</td>
                  <td
                    style="padding: 0.1px"
                    v-if="current_devolucion"
                    class="text-center text-success"
                    COLSPAN="4"
                  >
                    {{ current_devolucion.fecha_creacion | moment("DD/MM/YYYY hh:mm a") }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 0.1px" class="text-left font-weight-bold">
                    Referencia
                  </td>
                  <td
                    v-if="current_devolucion"
                    style="padding: 0.1px"
                    class="text-center text-success"
                    COLSPAN="4"
                  >
                    {{ current_devolucion.referencia }}
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="current_devolucion"
                    style="padding: 0.1px"
                    class="font-weight-bold text-left"
                  >
                    <span>Monto</span>
                  </td>
                  <td
                    v-if="current_devolucion"
                    style="padding: 0.1px"
                    class="font-weight-bold text-center text-success"
                  >
                    Q
                    <span class="text-success"> {{ current_devolucion.valor }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center" style="background-color: rgb(144, 238, 144)">
              <span>Detalle Devolución</span>
            </div>
            <div class="table" style="overflow-y: scroll; max-height: 200px">
              <table
                class="table table-bordered"
                style="overflow-y: scroll; max-height: 200px; background-color: #e7f1e7"
              >
                <thead>
                  <th style="padding: 0.5px" class="text-center">SKU</th>
                  <th style="padding: 0.5px" class="text-center">UNIDADES</th>
                  <th style="padding: 0.5px" class="text-center">SUBTOTAL</th>
                </thead>
                <tbody>
                  <tr v-for="det in detalle_devolucion" :key="det.id">
                    <td style="padding: 0.5px" class="font-weight-bold text-center">
                      <span class="text-success">{{ det.producto.sku }}</span>
                    </td>
                    <td style="padding: 0.5px" class="font-weight-bold text-center">
                      {{ det.cantidad }}
                    </td>
                    <td style="padding: 0.5px" class="font-weight-bold text-center">
                      <span class="text-success">Q{{ det.valor_total }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="pendiente <= 0" class="text-center">
              <span style="color: blue; font-size: 13px" class="font-weight-bold">
                PAGO DE DEVOLUCIÓN COMPLETADO <i class="fas fa-check"></i
              ></span>
              <hr />
            </div>
            <div class="text-center" style="background-color: rgb(144, 238, 144)">
              <span>Resumen Aplicación</span>
            </div>
            <table class="table table-bordered">
              <thead>
                <th style="padding: 0.5px" class="text-center">Pendiente</th>
                <th style="padding: 0.5px" class="text-center">Saldo Abonado</th>
                <th style="padding: 0.5px" class="text-center">Por Abonar</th>
              </thead>
              <tbody>
                <tr>
                  <td
                    style="padding: 0.5px"
                    v-bind:class="{
                      'text-dark': pendiente > 0,
                      'text-success': pendiente == 0,
                      'text-danger': pendiente < 0,
                    }"
                    class="font-weight-bold text-center"
                  >
                    Q
                    <span>{{ pendiente }}</span>
                  </td>
                  <td style="padding: 0.5px" class="font-weight-bold text-center">
                    Q<span class="text-success" v-if="current_devolucion">
                      {{ current_devolucion.abonado }}</span
                    >
                  </td>
                  <td
                    style="padding: 0.5px"
                    v-bind:class="{
                      'text-dark': por_abonar == 0,
                      'text-success': por_abonar > 0,
                    }"
                    class="font-weight-bold text-center"
                  >
                    Q<span> {{ por_abonar }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-------------------- END - Basic Table -------------------->
            <div class="col-12">
              <span style="color: blue" class="text-center"
                >{{ currentDetalle.producto.sku }} -
                {{ currentDetalle.producto.nombre }}</span
              >
              <span v-if="error" class="text-danger">{{ error }}</span>
              <input
                type="text"
                v-bind:class="{
                  'text-danger border-danger': currentDetalle.errors.producto,
                }"
                style="font-weight: bold"
                class="form-control form-control-sm"
                placeholder="Barra de producto"
                v-model="currentDetalle.barra"
                v-on:keyup.enter="refreshProducto()"
              />
              <small
                class="text-danger"
                v-if="currentDetalle.errors && currentDetalle.errors.producto"
                >{{ currentDetalle.errors.producto[0] }}</small
              >
            </div>
            <div
              v-if="currentDetalle.producto && currentDetalle.producto.sku"
              class="col-12"
            >
              <label>Cantidad</label>
              <input
                type="text"
                v-bind:class="{
                  'text-danger border-danger': currentDetalle.errors.cantidad,
                }"
                style="font-weight: bold"
                class="form-control form-control-sm"
                placeholder="cantidad"
                v-model="currentDetalle.cantidad"
                @input="costoPorabonar()"
              />
              <small
                class="text-danger"
                v-if="currentDetalle.errors && currentDetalle.errors.cantidad"
                >{{ currentDetalle.errors.cantidad }}</small
              >
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="agregaDetalle()" type="button">
              agregar detalle <i class="fas fa-plus"></i>
            </button>
            <button
              class="btn btn-outline-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
              @click="resetInfo()"
            >
              Cerrar <i class="fas fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalCreateNew"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h6>Crear una nueva recepción devolución</h6>
            <div class="col-12">
              <TiendaSelectComponent :current="current_" />
            </div>
            <div class="col-12">
              <ProveedoresSelectComponent :current="current_" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="guardar()" type="button">
              Guardar <i class="fas fa-save"></i>
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar <i class="fas fa-door-open"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    TiendaSelectComponent,
    ProveedoresSelectComponent,
  },
  props: ["devs", "current"],
  data() {
    return {
      productos: [],
      det: { referencia: null },
      current_: {
        errors: null,
      },
      error: "",
      pendiente: "",
      current_devolucion: {},
      por_abonar: 0,
      costo_producto: "",
      detalle_devolucion: [],
      currentDetalle: {
        cantidad: "",
        posicion: "",
        producto: "",
        barra: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  watch: {
    devs: function () {
      let self = this;
      if (self.current_devolucion && self.current_devolucion.id) {
        self.refreshDataModal();
      }
    },
  },
  mounted() {},
  methods: {
    refreshDevolucion(devolucion) {
      let self = this;
      DynamicService.getById("inv", "devolucion_proveedor", devolucion).then(
        (response) => {
          self.detalle_devolucion = response.data.devolucionproveedord_set;
        }
      );
    },
    costoPorabonar() {
      let self = this;
      self.por_abonar = (self.costo_producto * self.currentDetalle.cantidad).toFixed(3);
      self.pendiente = (self.current_devolucion.pendiente - self.por_abonar).toFixed(3);
    },
    refreshCostoProducto(d) {
      let self = this;
      DynamicService.getActionList(
        "wms",
        "recepcion_dev_prov_e",
        "obtener_costo_producto",
        { producto: d.sku }
      ).then((response) => {
        self.costo_producto = response.data;
      });
    },
    refreshProducto() {
      let self = this;
      self.error = "";
      DynamicService.fetch("cat", "producto-barra", {
        barra: self.currentDetalle.barra,
      }).then((response) => {
        self.currentDetalle.producto = response.data.results;
        if (self.currentDetalle.producto && self.currentDetalle.producto[0]) {
          self.currentDetalle.producto = self.currentDetalle.producto[0].producto_obj;
          self.refreshCostoProducto(self.currentDetalle.producto);
        } else {
          self.error = "No existe el producto";
        }
      });
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      if (self.current_.proveedor) {
        self.current_.proveedor = self.current_.proveedor.codigo;
      }
      DynamicService.save("wms", "recepcion_dev_prov_e", self.current_)
        .then((response) => {
          $("#modalCreateNew").modal("hide");
          self.$router.push({
            name: "inventario-recepcion_devolucion-editar",
            params: { id: response.data.id },
          });
        })
        .catch((error) => {
          self.current_.errors = error.response.data;
        });
    },
    rowClick(det) {
      let self = this;
      self.current_devolucion = det;
      $("#modalInfoDevs").modal();
      $("#modalAddDetailDevs").modal("hide");
      self.pendiente = det.pendiente;
      self.refreshDevolucion(det.id);
    },
    refreshDataModal() {
      let self = this;
      self.current_devolucion = self.devs.filter(function (det) {
        return det.id == self.current_devolucion.id;
      });
      self.current_devolucion = self.current_devolucion[0];
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      det.pendiente = self.current_devolucion.pendiente;
      det.por_abonar = self.por_abonar;
      det.devolucion_proveedor_e = self.current_devolucion.id;
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      DynamicService.postAction(
        "wms",
        "recepcion_dev_prov_e",
        self.current.id,
        "agregar_detalle",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar detalle",
            "Se ha guardado la Información."
          );
          this.$emit("refreshDevspendientes");
          self.resetInfo();
        })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.alert.error("Agregar detalle", error.response.data.detail);
          }
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },
    resetInfo() {
      let self = this;
      self.currentDetalle.producto = "";
      self.currentDetalle.barra = "";
      self.currentDetalle.cantidad = "";
      self.currentDetalle.errors = "";
      self.por_abonar = "";
    },
  },
};
</script>
